import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Divider, Box } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectWithCreateProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  onCreateNew: () => void;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  fullWidth?: boolean;
  createButtonText?: string;
}

export const SelectWithCreate: React.FC<SelectWithCreateProps> = ({
  label,
  value,
  onChange,
  options,
  onCreateNew,
  error = false,
  helperText,
  required = false,
  fullWidth = true,
  createButtonText = 'Add New',
}) => {
  const [open, setOpen] = useState(false);

  const handleChange = (event: any) => {
    onChange(event.target.value);
  };

  const handleCreateNew = () => {
    setOpen(false);
    onCreateNew();
  };

  return (
    <FormControl fullWidth={fullWidth} error={error}>
      <InputLabel required={required}>{label}</InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        label={label}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
        {options.length > 0 && <Divider />}
        <MenuItem onClick={handleCreateNew} sx={{ color: 'primary.main' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <AddIcon fontSize="small" />
            {createButtonText}
          </Box>
        </MenuItem>
      </Select>
      {helperText && (
        <Box sx={{ color: 'error.main', fontSize: '0.75rem', mt: 0.5 }}>
          {helperText}
        </Box>
      )}
    </FormControl>
  );
};
